import React from 'react';

// Components //
import TitleSection from "../../molecules/title-section";
import Button from "../../atoms/button/button";

// Utils //
import contentfulRenderOptions from '../../../utils/contentfulRenderOption';

// Interface //
import { ReferenciaContenido } from '../../../interfaces/ReferenciaContenido';

// Styles //
import "./MentorshipRecommendationsRight.scss";
import { withPrefix } from 'gatsby';

const MentorshipRecommendationsRight = (props: ReferenciaContenido) => {
    const isFrecuent : boolean = location.pathname.includes("personas/agencia-transnacional/destinos-frecuentes/");
    console.log(isFrecuent)
    return (
        <div className={`o-mentorship-recommendations-right ${isFrecuent ? "o-mentorship-recommendations-right--frecuent "+ props.tituloGeneral : ""}`} data-contentful-id={props.contentful_id}>
                <div id={isFrecuent ? props.tituloGeneral : ""} className={`o-mentorship-recommendations-right__inner ${props.contentful_id === "5IOa6GfhSEQ0ESmDeURPTE" ||
                    props.contentful_id === "1hudfqvjOo6Kw0sL7P72gw" ? "o-mentorship-recommendations-right__inner--grey" :""}`}>
                    <div className="o-mentorship-recommendations-right__inner__text">
                        <TitleSection title={props.tituloGeneral}  />
                        {contentfulRenderOptions(props.descripcion.json)}
                        {props.tituloBoton && (
                            <Button
                                type="link"
                                text={props.tituloBoton}
                                classname={`a-button__magenta o-mentorship-recommendations-right__cta`}
                                isDisabled={false}
                                href={withPrefix(props.redireccionBoton)}
                            />
                        )}
                    </div>
                    <div className="o-mentorship-recommendations-right__inner__image">
                        <img src={props.imagenPrincipal.file.url} alt={props.imagenPrincipal.file.fileName} />
                    </div>
                </div>
            </div>
    )
}

export default MentorshipRecommendationsRight;